module.exports = __webpack_public_path__ + "img/channel-en.25d3181b.png";